import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Label, Stack } from '@bingads-webui-react/fabric-control';
import { HelpPopup } from '@bingads-webui-react/help-popup';
import DataTrending from '../../../media/data-trending.svg';


const PredictiveTargetingDescription = ({ i18n }) => (
  <div>
    {i18n.getString(_TL_('Predictive targeting allows us to optimize your ad reach based on your targeting preferences. You can customize predictive targeting by setting up targeting preferences below.'))}
    &nbsp;<a className="HelpTopic" href="#!" query="help:app54818">{i18n.getString(_TL_('Learn more'))}</a>
  </div>
);

PredictiveTargetingDescription.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};

export const PredictiveTargetingHeader = ({ data }) => {
  const i18n = useContext(I18nContext);

  const { UseOptimizedTargeting } = data;

  return (
    <>
      <Stack>
        <Stack horizontal tokens={{ childrenGap: 14 }}>
          <img src={DataTrending} alt={i18n.getString(_TL_('Predictive targeting logo'))} />
          <Stack verticalAlign="center" tokens={{ childrenGap: 14 }}>
            <Label className="collapse-title" isActive>
              {UseOptimizedTargeting && i18n.getString(_TL_('Predictive targeting is enabled'))}
              { !UseOptimizedTargeting && i18n.getString(_TL_('Predictive targeting is not set up for this campaign')) }
              <HelpPopup
                topic="pop_BA_PredictiveTargeting_OptimizedDisabled"
                aria-label={i18n.getString(_TL_('Click to learn more about {{item}}'), { item: 'Predictive Targeting' })}
              />
            </Label>
            <div>
              <PredictiveTargetingDescription i18n={i18n} />
            </div>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};

PredictiveTargetingHeader.propTypes = {
  data: PropTypes.shape({
    UseOptimizedTargeting: PropTypes.bool,
  }).isRequired,
};

